<div class="mb-5">
	<app-daily-utilization-chart
		*ngIf="data"
		[chart]="chart"
		[tooltipText]="'utilization.daily_amp_hour_battery_fleet_utilization_title' | translate"
		[vAxisTitle]="'site.number_of_trucks' | translate"
	></app-daily-utilization-chart>
</div>
